function marketoFormValidationHandler(marketoForm, ourForm) {
    return (validationSuccess) => {
        if (validationSuccess) {
            return;
        }
        ourForm[0].dispatchEvent(
            new CustomEvent('validation-failed', {
                detail: {
                    marketoForm: marketoForm,
                    ourForm: ourForm,
                    invalidInputs: jQuery('.mktoInvalid', marketoForm.getFormElem()),
                },
            }),
        );
    };
}

const submitMarketoForm = (form) => {
    const $form = jQuery(form);
    var marketoForm = MktoForms2.getForm($form.data('id'));
    var vals = $form.serializeArray()
        .reduce(function (vals, field) {
            vals[field.name] = field.value;
            return vals;
        }, {});
    marketoForm.setValues(vals);
    jQuery('input[type="checkbox"]', form)
        .toArray()
        .forEach((customCheckbox) => {
            let marketoCheckbox = jQuery(`input[name="${customCheckbox.name}"]`, marketoForm.getFormElem());
            marketoCheckbox.prop('checked', customCheckbox.checked);
        });
    disableSubmitButton(form);
    marketoForm.submit();
}

function loadMarketoForms() {
    var forms = document.querySelectorAll('form.mkto-custom-thanks,form.mkto-custom-form:not(.sheets-form)');

    if (jQuery('script[src="//app-ab19.marketo.com/js/forms2/js/forms2.min.js"]').length > 0) {
        // Forms already loaded
        console.log('forms already loaded');
        return;
    }

    // load marketo lib
    var mktoLibScript = document.createElement('script');
    mktoLibScript.type = 'text/javascript';
    mktoLibScript.src = '//app-ab19.marketo.com/js/forms2/js/forms2.min.js';
    mktoLibScript.defer = true;
    mktoLibScript.onload = () => {
        setTimeout(() => {
            const loadForm = (form) => {
                MktoForms2.loadForm(form.dataset.baseUrl || '//app-ab19.marketo.com', form.dataset.munchkinId || '280-XQP-994', form.dataset.id, function ($form) {
                    // Setup on success message
                    if (form.classList.contains('mkto-custom-thanks')) {
                        $form.onSuccess(() => {
                            // Add custom thank you message
                            form.innerHTML = '<p class="marketo-thank-you">' + form.getAttribute("data-thank-you") + '</p>';
                            // prevent default success handler
                            return false;
                        });
                    }
                    if (form.classList.contains('custom-success')) {
                        $form.onSuccess(() => {
                            var customForm = jQuery('form[data-id="' + $form.getId() + '"].submitting')[0];
                            customForm.classList.remove('submitting');
                            customForm.classList.add('success');
                            var submitButton = jQuery('button', customForm);
                            submitButton
                                .removeClass('submitting')
                                .html(submitButton.data('success-message'));
                            return false;
                        });
                    }
                    // Reddit Ads
                    const listOfRadFromIds = ['2799', '2713']
                    if (window.rdt && listOfRadFromIds.includes(form.dataset.id)) {
                        window.rdt('track', 'ViewContent')
                    }
                });
            };
            let loadedForms = [];
            for (const form of forms) {
                if (loadedForms.includes(form.dataset.id)) {
                    continue;
                }
                loadForm(form);
                loadedForms.push(form.dataset.id)
            }
            MktoForms2.whenReady((form) => {
                form.onSubmit(() => {
                    const vals = form.vals();
                    const formElement = form.getFormElem()[0]
                    const submitText = document.querySelector(`form.custom-marketo-form[data-id="${form.getId()}"] [type="submit"], form.customized-marketo-form[data-id="${form.getId()}"] [type="submit"]`).innerText
                    const googleEvent = {
                        event: 'marketoFormSubmit',
                        marketoFormId: form.getId(),
                        marketoCompany: vals.Company,
                        marketoTitle: vals.Title,
                        marketoLeadSource: vals.LeadSource,
                        marketoOriginalSource: vals.Original_Source_Detail__c,
                        marketoCurrentSource: vals.Source_Detail__c,
                        submitButtonText: submitText,
                        submitDetails: `${submitText} | ${vals.Account_Type__c} | ${vals.PC_Primary_Topic_Interest__c} | ${vals.Existing_Affiliate_Program__c} | ${form.getId()}`,
                    };
                    if (vals.Account_Type__c) {
                        googleEvent.Account_Type__c = vals.Account_Type__c
                    }
                    if (vals.PC_Primary_Topic_Interest__c) {
                        googleEvent.PC_Primary_Topic_Interest__c = vals.PC_Primary_Topic_Interest__c
                    }
                    if (vals.Existing_Affiliate_Program__c) {
                        googleEvent.Existing_Affiliate_Program__c = vals.Existing_Affiliate_Program__c
                    }
                    dataLayer.push(googleEvent);
                    // Capterra conversion tracking
                    window.capterraConversion();

                    enrichMarketoFormWithImpactUTT(formElement);

                    // UTM tracking
                    if (window.sessionStorage.getItem('utmmedium')) {
                        const utmParameterNames = [
                            'utmmedium',
                            'utmsource',
                            'utmcampaign',
                            'utmcontent',
                            'utmkeyword',
                        ];
                        for (const utmName of utmParameterNames) {
                            const utmField = formElement.querySelector(`input[name="${utmName}"]`);
                            if (!utmField) {
                                continue
                            }
                            utmField.value = window.sessionStorage.getItem(utmName);
                        }
                    }
                    // Gated content
                    const gatedContentForm = jQuery('form.custom-marketo-form.gated[data-id="' + form.getId() + '"]');
                    if (gatedContentForm.length > 0) {
                        dataLayer.push({
                            ...googleEvent,
                            'event': 'gatedContentFormSubmitted',
                            'contentType': jQuery('.article-container')
                                .data('content-type'),
                        });
                    }
                    // Opens URL in a new tab on submission
                    const openNewTab = jQuery('form.custom-marketo-form.open-new-tab[data-id="' + form.getId() + '"]');
                    if (openNewTab.length > 0) {
                        const formName = document.querySelector('form[data-formname]').dataset.formname;
                        fetch(`/wp-admin/admin-ajax.php?action=new_tab_url&formname=${(formName)}`)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(`Failed to open downloaded file in a new tab for ${formName} form`)
                                }
                                return response.json()
                            })
                            .then(data => {
                                window.open(data.url, '_blank');
                            })
                    }
                });
                form.onSuccess(() => {
                    const vals = form.vals();
                    const submitText = document.querySelector(`form.custom-marketo-form[data-id="${form.getId()}"] [type="submit"], form.customized-marketo-form[data-id="${form.getId()}"] [type="submit"]`).innerText

                    const eventDetails = {
                        marketoFormId: form.getId(),
                        phone_number: vals.Phone,
                        email: vals.Email,
                        marketoCompany: vals.Company,
                        marketoTitle: vals.Title,
                        marketoLeadSource: vals.LeadSource,
                        marketoOriginalSource: vals.Original_Source_Detail__c,
                        marketoCurrentSource: vals.Source_Detail__c,
                        submitButtonText: submitText,
                        submitDetails: `${submitText} | ${vals.Account_Type__c} | ${vals.PC_Primary_Topic_Interest__c} | ${vals.Existing_Affiliate_Program__c} | ${form.getId()}`,
                    }
                    if (vals.Account_Type__c) {
                        eventDetails.Account_Type__c = vals.Account_Type__c
                    }
                    if (vals.PC_Primary_Topic_Interest__c) {
                        eventDetails.PC_Primary_Topic_Interest__c = vals.PC_Primary_Topic_Interest__c
                    }
                    if (vals.Existing_Affiliate_Program__c) {
                        eventDetails.Existing_Affiliate_Program__c = vals.Existing_Affiliate_Program__c
                    }

                    // Demo form submitted
                    const listOfRadFromIds = [2799, 2713]
                    if (listOfRadFromIds.includes(form.getId()) && vals.Account_Type__c === 'Advertiser') {
                        // GTM
                        dataLayer.push({event: 'demoFormSubmitted', ...eventDetails})
                        // Facebook
                        window.fbq && window.fbq('trackCustom', 'Demo')
                        // Bing Ads
                        window.uetq && window.uetq.push('event', 'Demo', {})
                        // Mutiny
                        window.mutiny && window.mutiny.client.trackConversion({name: 'Demo'})
                        // LinkedIn CAPI (Demo)
                        vals.Email && sendLinkedInCapiEvent(19056860, vals.Email)
                        // Reddit Ads
                        window.rdt && window.rdt('track', 'SignUp')
                    }
                    else {
                        // GTM
                        dataLayer.push({event: 'leadFormSubmitted', ...eventDetails})
                        // Facebook
                        window.fbq && window.fbq('track', 'Lead')
                        // Bing Ads
                        window.uetq && window.uetq.push('event', 'Lead', {})
                        // Mutiny
                        window.mutiny && window.mutiny.client.trackConversion({name: 'Lead'})
                        // LinkedIn CAPI (Lead)
                        vals.Email && sendLinkedInCapiEvent(19056852, vals.Email)
                        // Reddit Ads
                        window.rdt && window.rdt('track', 'Lead')
                    }
                })
                // TODO need to investigate if this is still required
                var isInList = [3278, 2802, 2799, 1633, 2571, 2729, 2152, 2237, 2256, 1367, 1372, 1929, 2672, 2683].includes(form.getId());
                if (!isInList) {
                    return;
                }
                var actionInputs = jQuery('.form_action input');
                actionInputs.on('focus', function () {
                    jQuery(this)
                        .parent()
                        .find('label')
                        .addClass("small");
                });
                actionInputs.on('focusout', function () {
                    if (jQuery(this)
                        .val() === "") {
                        jQuery(this)
                            .parent()
                            .find('label')
                            .removeClass("small");
                    }
                    if (jQuery(this)
                        .hasClass("mktoInvalid")) {
                        jQuery(this)
                            .addClass("invalid");
                    }
                    else if (jQuery(this)
                        .hasClass("mktoValid")) {
                        jQuery(this)
                            .addClass("valid");
                    }
                });
                jQuery('.form_action select')
                    .on('change', function () {
                        jQuery(this)
                            .addClass("valid");
                    });
                jQuery('.form_action option[value=""]')
                    .attr("disabled", "disabled");
            });
        }, 10);
    };
    mktoLibScript.onerror = (error) => {
        console.error('Failed to load Marketo library ', error);
        window.Sentry && Sentry.captureException(error);
        Array.from(document.querySelectorAll('.custom-marketo-form, .customized-marketo-form'))
            .forEach(
                function (form) {
                    form.classList.add('error');
                },
            );

    }
    document.body.appendChild(mktoLibScript);

}

onLoad(() => {
    // Support embedded / preload forms
    var preloadForms = document.querySelectorAll('form[preload]');
    if (preloadForms.length > 0) {
        loadMarketoForms();
    }
});
